export default "__VITE_ASSET__Nkd2rJhI__"